
import { endpoints } from "../apis"
import { setLoading } from "../../slices/authSlice";
import { toast } from "react-toastify";
import { apiConnector } from "../apiConnector";
import { message } from "../../components/messages/Messages";
import { getUserDetails } from "./ProfileAPI";


const {CREATE_BULK_JOB_POST,CREATE_JOB_POST,GET_GLOBAL_JOB_LIST,GET_JOB_POST,WRITE_WITH_AT,GET_GLOBAL_THREE_LIST,GET_PASSIVE_CANDIDATES,GET_APPLICANTS,CHANGE_STATUS}=endpoints;
const BASE_URL = process.env.REACT_APP_BASE_URL


export function createJobPost(payload,token,onClose) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const response = await apiConnector("POST", CREATE_JOB_POST, payload, { 'Authorization': `Bearer ${token}` })
      if (response?.status === 201) {
        dispatch(setLoading(false));
        onClose();
        toast.success(response.data.message)
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 422) {
        onClose();
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        onClose();
        toast.error(error.response.data.message);
      }
    }
  }
}

export function createBulkJobPost(payload,token,onClose) {
  return async (dispatch) => {
//  dispatch(setLoading(true))
    try {
        const response = await apiConnector("POST", CREATE_BULK_JOB_POST, payload, { 'Authorization': `Bearer ${token}` })
      if (response?.status === 201) {
        dispatch(setLoading(false));
        onClose();
        toast.success(response.data.message)
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 422) {
        onClose();
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        onClose();
        toast.error(error.response.data.message);
      }
    }
  }
}

export function getJobPost(token,params={}) {
  return async (dispatch) => {
//dispatch(setLoading(true))
    try {
        const response = await apiConnector("GET", GET_JOB_POST, "", { 'Authorization': `Bearer ${token}` },params)
      if (response?.status === 200) {
      //dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
     //dispatch(setLoading(false));
      if (error?.response?.status === 422) {
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function viewJobPost(token,id) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const url=BASE_URL+`api/view-job-posting/${id}`
        const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
        const response = await apiConnector("GET", url, "", headers)
      if (response?.status === 200) {
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 422) {
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function editJobPost(payload,token,onClose,id) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const url=BASE_URL+`api/edit-job-posting/${id}`
        const response = await apiConnector("PUT", url, payload, { 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message)
        onClose()
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
        toast.error(error.response.data.message)
        onClose()
      }
      if (error?.response?.status === 404) {
        toast.error(error.response.data.message)
        onClose()
      }
      
      if (error?.response?.status === 500) {
        onClose();
        toast.error(error.response.data.message);
       
      }
    }
  }
}

export function closeJobPost(payload,token,id) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const url=BASE_URL+`api/update-job-status/${id}`
        const response = await apiConnector("PATCH", url, payload, { 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message);
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
        toast.error(error.response.data.message)
      }
      if (error?.response?.status === 404) {
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function deleteJobPost(token,id) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const url=BASE_URL+`api/update-job-status/${id}`
        const payload={
          job_status:"DELETED"
        }
        const response = await apiConnector("PATCH", url, payload, { 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message)
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
        toast.error(error.response.data.message)
      }
      if (error?.response?.status === 404) {
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function writeWithAi(payload,token) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const response = await apiConnector("POST", WRITE_WITH_AT, payload, { 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 4043) {
        toast.error(error.response.data.message)
      }
      if (error?.response?.status === 404) {
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function getThreeJobs() {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const response = await apiConnector("GET", GET_GLOBAL_THREE_LIST, "",)
      if (response?.status === 200) {
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 4043) {
        toast.error(error.response.data.message)
      }
      if (error?.response?.status === 404) {
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function getTotalJobs(payload,page) {
  return async (dispatch) => {
 //dispatch(setLoading(true))
    try {
        const response = await apiConnector("POST", GET_GLOBAL_JOB_LIST, payload,"",{page:page})
      if (response?.status === 200) {
        //dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      //dispatch(setLoading(false));
      if (error?.response?.status === 4043) {
        return error.response;
      }
      if (error?.response?.status === 404) {
        return error.response;
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}


export function getPassiveCandidates(payload,token) {
  return async (dispatch) => {
 //dispatch(setLoading(true))
    try {
        const response = await apiConnector("POST", GET_PASSIVE_CANDIDATES, payload,{ 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        //dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      //dispatch(setLoading(false));
      if (error?.response?.status === 403) {
        return error.response;
      }
      if (error?.response?.status === 404) {
        return error.response;
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}


export function getApplicantList(payload,token) {
  return async (dispatch) => {
 //dispatch(setLoading(true))
    try {
        const response = await apiConnector("POST", GET_APPLICANTS, payload,{ 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        //dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      //dispatch(setLoading(false));
      if (error?.response?.status === 403) {
        return error.response;
      }
      if (error?.response?.status === 404) {
        return error.response;
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}


export function  changeHiringStatus(payload,token) {
  return async (dispatch) => {
  dispatch(setLoading(true))
  try{
     const response = await apiConnector("POST", CHANGE_STATUS, payload,{ 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message)
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
      toast.error(error.response.data.message)
      }
      if (error?.response?.status === 404) {
          toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.message);
      }
    }
  }
}